import { george, observer, React, ui } from "aaa";
import { ContactsStore, phoneNumberToString } from "stores/ContactsStore";

/**
 * Render a drop down with a users mobile phones
 */
export const MobilePhonesDropDown = observer((props: {
    contactsStore: ContactsStore,
    onSelectionChanged: (mobilePhoneId: string) => void,
    selectedPhoneId?: string,
    onNewPhone?: () => void,
    allowNewPhone?: boolean,
    white?: boolean
}) => {
    const ADD_NEW_KEY = "addNew";

    let phoneNumbers: { value: string, label: string }[] = [];
    const store = props.contactsStore;
    if (store.mobilePhones && store.mobilePhones.length > 0) {
        phoneNumbers = store.mobilePhones.map(contact => {
            return {
                value: contact.id,
                label: phoneNumberToString(contact)
            };
        });
    }

    if (props.allowNewPhone === true) {
        phoneNumbers.push({ value: ADD_NEW_KEY, label: ui.__("phone.addNew") });
    }

    return (
        <george.DropDown
            isLoading={props.contactsStore.isLoading}
            white={props.white}
            value={props.selectedPhoneId ? props.selectedPhoneId : (phoneNumbers[0] && phoneNumbers[0].value)}
            onChange={(event: any, index: number, value: string) => {
                if (value === ADD_NEW_KEY) {
                    if (props.onNewPhone) {
                        props.onNewPhone();
                    }
                } else {
                    props.onSelectionChanged(value);
                }
            }}
            onClick={() => {
                // Hack for a11y: We want to trigger new phone when using native rendering
                if (phoneNumbers.length === 1
                    && phoneNumbers[0].value === ADD_NEW_KEY
                    && props.onNewPhone
                ) {
                    props.onNewPhone();
                }
            }}
            aria-label={ui.__("a11y.choosePhoneNumber")}
            items={phoneNumbers}
        />
    );
});



// WEBPACK FOOTER //
// ./src/components/common/MobilePhonesDropDown.tsx